import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@shared/services/auth.service';
import { ToastService } from '../services/toast.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const toastService = inject(ToastService);

  if (authService.isLoggedIn()) {
    const user = authService.currentUser();
    // Aceptamos tanto la propiedad active como status === 'ACTIVE'
    const isActive = user?.active !== false && user?.status !== 'INACTIVE';
    if (isActive) {
      return true;
    } else {
      toastService.show(
        'Acceso Denegado',
        'Tu cuenta está inactiva. Contacta a soporte técnico.',
        'error',
        5000
      );
      authService.logout();
      router.navigate(['/auth/login']);
      return false;
    }
  }

  // No está autenticado
  router.navigate(['/auth/login']);
  return false;
};
